import React, { type ErrorInfo, useCallback } from 'react';

import { ErrorBoundary, type ErrorBoundaryProps } from 'react-error-boundary';

interface GenericErrorBoundaryProps {
	children: ErrorBoundaryProps['children'];
	fallback?: ErrorBoundaryProps['fallback'];
	/**
	 * The name of the component using this error boundary to help identify where errors occur.
	 */
	name: string;
	onError?: ErrorBoundaryProps['onError'];
}

export function GenericErrorBoundary({
	children,
	fallback = null,
	onError = undefined,
}: GenericErrorBoundaryProps) {
	const onErrorCallback = useCallback(
		(error: Error, errorInfo: ErrorInfo) => {
			// TODO: NAVX-3095 add sentry error tracking
			onError?.(error, errorInfo);
		},
		[onError],
	);

	return (
		<ErrorBoundary fallback={fallback} onError={onErrorCallback}>
			{children}
		</ErrorBoundary>
	);
}
